/**
 * File component.
 * Displays uploaded file(s).
 *
 * Source: https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
 * Usage:
 * Call File.init() to initialize all $wrappers.
 *
 * Methods:
 *
 * init(): attaches eventlisteners
 */

const init = function() {
	const $wrappers = document.querySelectorAll('.js-file');
	Array.prototype.forEach.call($wrappers, $wrapper => {
		const $input = $wrapper.querySelector('input');
		const $label = $wrapper.querySelector('.js-file-label');

		const labelVal = $label.innerHTML;

		$input.addEventListener('change', function(e) {
			let fileName = '';
			if (this.files && this.files.length > 1) {
				fileName = (this.getAttribute('data-multiple-caption') || '').replace(
					'{count}',
					this.files.length
				);
			} else {
				fileName = e.target.value.split('\\').pop();
			}

			if (fileName) {
				$label.innerHTML = fileName;
			} else {
				$label.innerHTML = labelVal;
			}
		});
	});
};
module.exports = {
	init
};
